export default {
    state: {
        api: process.env.VUE_APP_API_HOST + '/api',
        storage: process.env.VUE_APP_API_HOST + '/storage',
    }
};